export const enum NetworkActionTypes {
    NETWORK_STATUS_CHANGED = '@@network/NETWORK_STATUS_CHANGED'
  }

export interface NetworkState {
    isConnected: boolean;
    actionQueue: Array<any>;
}
